<template>
  <div>
  <div class="margin-tb-xs  padding  bg-gray-light" v-for="(item,i) in dataSource" :key="i">
           <div class="flex algin-center ">
                <ClockCircleOutlined class="text-gray" />
                <span class="flex1 text-bolder text-lg margin-left-xs">{{ item.Timer }}</span>
                <CloseOutlined   @click="del(i)" />
           </div>
           <div class="text-gray text-sm">
            <template v-if="item.ExtType==0">
               <span class="text-green margin-right-xs">应用于所有盘煤仪</span>
            </template>
            <template v-else>
               <span v-if="item.ExtType==1" class="text-primary  margin-right-xs">应用于盘煤仪:</span>
               <span v-else class="text-red margin-right-xs">排除盘煤仪:</span>
                <template v-if="item.ExtDevice&&item.ExtDevice.length>0">
                   <a-select disable :value="item.ExtDevice"  mode="multiple" :options="devices" :fieldNames="{label:'DeviceName',value:'DeviceNo'}"></a-select>
                </template>
                <template v-else>
                    <span class="text-sm text-gray">未指定</span>
                </template>
            </template>
           </div>
           <a-divider />
           <div >
              <a-tag color="success">{{ getStartCount(item) }}</a-tag> 台盘煤仪将在每日{{item.Timer}}启动
           </div>
    </div>
    <div class="text-center margin-tb text-center">
        <a-button type="primary" shape="circle" @click="onAdd"><PlusOutlined /></a-button>
    </div>
    <a-modal title="盘煤仪设置" v-model:open="open" @ok="submit">
      <a-form v-if="act">
        <a-form-item label="启动时间">
          <span class="margin-right-xs">每天</span>
          <a-time-picker v-model:value="act.Timer" valueFormat="HH:mm"></a-time-picker>
        </a-form-item>
        <a-form-item label="启动类型">
          <a-radio-group optionType="button" :value="act.ExtType" :options="exttypes" :onChange="radioChange">
          </a-radio-group>
        </a-form-item>
        <a-form-item label="指定设备" v-if="act.ExtType>0">
           <a-select v-model:value="act.ExtDevice"  mode="multiple" :options="devices" :fieldNames="{label:'DeviceName',value:'DeviceNo'}"></a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script setup lang="ts">
import api from '@/utils/http/service'
import {  ClockCircleOutlined,PlusOutlined,CloseOutlined} from '@ant-design/icons-vue'
import {onMounted,defineProps,ref,watch,reactive,createVNode,defineComponent} from 'vue'
import {message}  from  'ant-design-vue'
const open=ref(false)
const act=ref<any>(null)
const devices=ref([])
const dataSource=ref([{
  Timer:'16:00',
  ExtDevice:[],
  ExtType:0 //0,用于所有设备,1用于指定设备，2排除指定设备
}])
const exttypes=reactive([
  {label:"所有盘煤仪",value:0},
  {label:"应用于指定盘煤仪",value:1},
  {label:"排除指定盘煤仪",value:2},
])
function onAdd(){
  act.value={Timer:'',ExtDevice:[],ExtType:0}
  open.value=true
}
function radioChange(e){
  act.value.ExtType=e.target.value
}
function getStartCount(item){
  if(item.ExtType==1){
     return  item.ExtDevice.length
  }else if(item.ExtType==2){
     return devices.value.length-item.ExtDevice.length
  }else {
    return devices.value.length
  }
}
function submit(){
  if(!act.value.Timer){
    message.error('请指定启动时间')
    return false
  }
  if(act.value.ExtType>0&&act.value.ExtDevice.length==0){
    message.error('请至少指定一个设备')
    return false
  }
  dataSource.value.push(act.value)

  open.value=false
  act.value=null
}
function del(i){
  dataSource.value.splice(i,1)
}
onMounted(()=>{
  api.scaner.list({pageFlag:false}).then(res=>{
    if(res.state==1){
      devices.value=res.data
    }
  })
})

</script>
